import * as Utils from 'ui/Utils';
import {validate} from 'privates/validations/validation';
import {runValidationsAndSyncAfterChange} from 'privates/validationsService/validationsService';
import * as members from 'privates/privateMembers';

/**
 * @mixin RequiredMixin
 * @summary Provides functionality for input elements can be required to have a value.
 * @memberof $w
 */
class RequiredMixin {

    /**
     * @member required
     * @label property
     * @syntax
     * get required(): boolean
     * set required(value: boolean): void
     * @summary Sets or gets whether an input element is required to have a value.
     * @description
     *  Setting the `required` property to `true` causes the
     *  element to be [invalid]($w.ValidatableMixin.html#.validity) if it
     *  doesn't contain a value. Setting it to false allows the element to be
     *  valid even if it doesn't contain a value. The validity of the element
     *  can be checked using its [`validity`]($w.ValidatableMixin.html#.validity)
     *  property.
     *
     *  Getting the value of the `required` property returns whether the element
     *  is required.
     *
     *  You can also set an input element to be required
     *  by using the element's Settings pane in the Editor.
     * @snippet [RequiredMixin-required_set.es6=Set an element to be required]
     * @snippet [RequiredMixin-required_get.es6=Get whether an element is required]
     * @type {external:Boolean}
     * @see [validity]($w.ValidatableMixin.html#validity)
     * @memberof $w.RequiredMixin
     * @attr {external:Boolean}
     */
    get required() {
        return Utils.getProp(this, 'required') || false;
    }

    /**
     * @param {external:Boolean} required
     * @ignore
     */
    set required(required) {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const compType = members._type.get(this).compType;
        if (!validate({
            compType,
            functionName: 'required',
            dataToValidate: {required},
            compName: this.id
        })) {
            return;
        }
        Utils.setProp(this, { required });
        runValidationsAndSyncAfterChange(RMI, compId);
    }
}

export default RequiredMixin;



// WEBPACK FOOTER //
// ./js/modules/ui/mixins/RequiredMixin.es6